import {call, put, takeLatest} from "redux-saga/effects";
import * as actions from "../action.constants";
import {
  saveContentTypes,
  saveEventFieldTypes,
  saveEventRules,
  saveEventWebhooks,
} from "../Actions/eventRule.actions";
import {
  getEventRulesAsync,
  createUpdateEventRuleAsync,
  deleteEventRuleAsync,
  getContentTypesAsync,
  getEventFieldTypesAsync,
  getEventWebhooksAsync,
} from "../AsyncActions/eventRule.async";

function* getEventRules(action = {}) {
  const {pageUrl = ""} = action;
  try {
    const response = yield call(getEventRulesAsync, pageUrl);
    if (response) {
      yield put(saveEventRules(response?.data));
    }
  } catch (e) {
    return e;
  }
}

function* createUpdateEventRule(action = {}) {
  const {payload, callback = () => {}, onError = () => {}} = action;
  let response;
  try {
    response = yield call(createUpdateEventRuleAsync, payload);
  } catch (e) {
    onError(e);
    return e;
  }
  // Outside the try: a failing callback is not a failed save.
  if (response) {
    callback();
  }
}

function* deleteEventRule(action) {
  const {callback = () => {}, payload} = action;
  try {
    const response = yield call(deleteEventRuleAsync, payload);
    if (response) {
      callback();
    }
  } catch (e) {
    return e;
  }
}
function* getContentTypes() {
  try {
    const response = yield call(getContentTypesAsync);

    if (response) {
      yield put(saveContentTypes(response?.data));
    }
  } catch (e) {
    return e;
  }
}

function* getEventFieldTypes() {
  try {
    const response = yield call(getEventFieldTypesAsync);
    if (response) {
      yield put(saveEventFieldTypes(response?.data));
    }
  } catch (e) {
    return e;
  }
}
function* getEventWebhook() {
  try {
    const response = yield call(getEventWebhooksAsync);
    yield put(saveEventWebhooks(response?.data ?? []));
  } catch (e) {
    return e;
  }
}
export function* EventRuleSaga() {
  yield takeLatest(actions.REQUEST_EVENT_FIELD_TYPES, getEventFieldTypes);
  yield takeLatest(actions.REQUEST_EVENT_WEBHOOKS, getEventWebhook);
  yield takeLatest(actions.REQUEST_CONTENT_TYPES, getContentTypes);
  yield takeLatest(actions.REQUEST_EVENT_RULES, getEventRules);
  yield takeLatest(actions.CREATE_UPDATE_EVENT_RULE, createUpdateEventRule);
  yield takeLatest(actions.DELETE_EVENT_RULE, deleteEventRule);
}
